// Specchio dei `default` di apps/backend/src/services/flow/nodeManifest.json:
// il frontend non legge il manifest (scelta di fase 1), quindi i due vanno
// tenuti allineati a mano.
// Dati iniziali di un nodo APPENA creato (palette o drag&drop nel flow editor).
//
// Questo è l'unico posto dove un default può stare: metterlo nell'idratazione di
// un pannello (`hydrate` / assegnazione da `props.nodeData`) farebbe sì che il
// semplice aprire il pannello di un nodo già esistente lo modifichi in silenzio.
const DEFAULTS_BY_TYPE = {
  botSays:          () => ({ text: '' }),
  botAsks:          () => ({ question: '', variableName: '', responseType: 'text', options: [], allowFreeText: true }),
  condition:        () => ({ variableName: '', operator: 'equals', value: '' }),
  ifCondition:      () => ({ branches: [{ id: 'b1', label: '', match: 'all', rules: [{ id: 'r1', variable: '', operator: 'equals', value: '' }] }] }),
  setVariable:      () => ({ variableName: '', value: '' }),
  executeCode:      () => ({ code: '', libs: [] }),
  apiCall:          () => ({ url: '', method: 'GET', headers: [], queryParams: [], body: '', responseVariable: '', timeoutMs: 10000 }),
  webSearch:        () => ({ query: '', domain: '', responseVariable: 'searchResults' }),
  intentVerifier:   () => ({ sourceVariable: 'trigger_intent', targetVariable: 'detected_intent', intents: [] }),
  useMcpTool:       () => ({ selectedToolId: '', botMcpServerId: '', toolName: '', mcpName: '', mcpIcon: 'extension', parameters: {}, resultVariable: 'result', onError: 'continue' }),
  botRespondWithKb: () => ({ sourceVariable: '', outputVariable: '', includeContext: true, minConfidenceScore: 0.5, maxDocuments: 3, onLowConfidence: 'use_generic_answer', onError: 'continue' }),
  toolInput:        () => ({ toolName: '', description: '', parameters: [], useConversationContext: true }),
  toolOutput:       () => ({ value: '' }),
  // `attachments` nasce a `{{attachments}}`: è la convenzione su cui si regge il
  // contratto del parametro webhookInput di tipo `binary` («il flow funziona senza
  // configurazione aggiuntiva»). Con il campo vuoto, un flow aggiornato per
  // ricevere il multipart caricherebbe il file, lo pagherebbe e non consegnerebbe
  // niente, in silenzio.
  sendMessage:          () => ({ conversationId: '{{conversation_id}}', message: '', attachments: '{{attachments}}' }),
  sendChatMessage:      () => ({ mode: 'text', message: '' }),
  waitForUserReply:     () => ({ variableName: '' }),
  triggerAgent:         () => ({ conversationId: '{{conversation_id}}', message: '' }),
  askAgent:             () => ({ prompt: '', outputVariable: '', useSystemPrompt: true, includeConversationData: true, outputFormat: 'text', channelType: '', storageIds: [], allowedTools: [] }),
  sendWhatsapp:         () => ({ phoneNumber: '{{whatsapp_from}}', message: '', attachments: '{{attachments}}' }),
  sendWhatsappTemplate: () => ({ phoneNumber: '{{whatsapp_from}}', templateName: '', templateLanguage: 'it', parameters: [], contentSid: '' }),
  activateTransfer:   () => ({ conversationId: '{{conversation_id}}', botMcpServerId: '', selectedToolId: '', toolName: '', mcpName: '', mcpIcon: 'support_agent', parameters: {} }),
  deactivateTransfer: () => ({ conversationId: '{{conversation_id}}' }),
  transferCall:       () => ({ destination: '', message: '' }),
  endCall:            () => ({ message: '' }),
  fetchHistory:       () => ({ conversationId: '{{conversation_id}}', targetVariable: 'history', limit: 100 }),
  webhookInput:       () => ({ parameters: [] }),
  webhookOutput:      () => ({ value: '' }),
  addTags:            () => ({ conversationId: '{{conversation_id}}', tags: [], replace: false }),
};

// Ogni voce è una fabbrica, non un letterale condiviso: array e oggetti annidati
// devono essere nuovi per ogni nodo, altrimenti due nodi dello stesso tipo
// finirebbero per condividere la stessa `options`/`parameters`.
export function getDefaultDataForType(type) {
  const make = DEFAULTS_BY_TYPE[type];
  return make ? make() : {};
}
